import { WidgetInitializer } from "../functions/widget-initializer";
import { Constants } from "../functions/constants";
import { ConfigUtils } from "../functions/config-utils";

import { Splide, SplideSlide } from '@splidejs/vue-splide';

var widgetInitializer = new WidgetInitializer(Constants.COMPONENTS.MEMBERS);
GlobalApp.registerInitializationHandler(Constants.COMPONENTS.MEMBERS, function () {
    widgetInitializer.initialize(initMembersApp);
});

function initMembersApp(element) {
    const config = ConfigUtils.getConfigFor(element);


    let vueApp = new Vue({
        el: '#' + element.id,
        data: {
            options: Constants.SLIDERS.MEMBERS,
            isSliderMounted: false,
            initializationReadyHook: GlobalApp.getInitializationReadyHook()
        },
        methods: {
            onSplideMounted(splide) {
                this.isSliderMounted = true;


                const isPaginationUpdated = this.updateSplidePagination(splide.options);
                if (isPaginationUpdated) {
                    splide.options = splide.options;
                }

                document.body.classList.add(Constants.CLASS_NAMES.BODY_SLIDERS_READY_CLASS);
                this.initializationReadyHook(element.id);
            },
            updateSplidePagination(options) {
                if (options.pagination !== this.doesSliderHavePager) {
                    options.pagination = this.doesSliderHavePager;
                    return true;
                }

                return false;
            },
        },
        components: {
            Splide,
            SplideSlide
        },
        computed: {
            config: () => config,
            slider: function () {
                if (!this.isSliderMounted)
                    return null;

                let slider = this.$refs.members_slider.splide;
                return slider;
            },
            sliderPageSize: function () {
                if (!this.slider)
                    return null;

                return this.slider.options.perPage;
            },
            doesSliderHavePager: function () {
                if (!this.sliderPageSize)
                    return false;

                if (config.items.length <= this.sliderPageSize)
                    return false;

                return true;
            },
        }
    });

    return vueApp.$el;
}